import SmarteditController from '@/utils/Controllers/SmarteditController';
import _isEmpty from 'lodash/isEmpty';
import { LazySwiperLatestWhenVisible } from '@/utils/Controllers/LazySwiperLatestController';

const SELECTOR = '.js-del-moodboard';

const loadController = async (slider, SwiperLib) => {
  const controller = await import(
    /* webpackChunkName: "DELCategoryMoodboardController-lib" */ '@/delonghi/Controllers/DELCategoryMoodboard/DELCategoryMoodboardController'
  );
  controller.default(slider, SwiperLib);
};

const init = () => {
  const entries = SmarteditController.getEditorialEntries(SELECTOR);
  if (!_isEmpty(entries)) {
    LazySwiperLatestWhenVisible(entries, async (slider, SwiperLib) => {
      loadController(slider, SwiperLib);
    });
  }
};

export default async () => {
  SmarteditController.addOnReprocessPageListener(init);
  init();
};
